import { useWorkspaceIdentity } from "@/hooks/use-workspace";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@rulebase/core/components";
import { IconSettingsGear2 } from "central-icons";
import { CallSummaryPreference } from "./call-summary-preference";
import { OrgAvatar } from "./ui/initials-avatar";

/**
 * Workspace identity above the prompt: who you are signed in as, and which
 * organization Beam is reading from. Both halves render only once their read
 * resolves, so the header never flashes a placeholder name.
 */
export function WorkspaceHeader() {
  const { organizationName, organizationLogoUrl, firstName } =
    useWorkspaceIdentity();

  return (
    <div className="flex w-full items-center justify-between gap-3">
      {organizationName ? (
        <div className="flex min-w-0 items-center gap-2.5">
          <OrgAvatar name={organizationName} logoUrl={organizationLogoUrl} />
          <span className="truncate text-sm font-medium text-neutral-700">
            {organizationName}
          </span>
        </div>
      ) : (
        <span />
      )}

      {firstName && (
        <div className="flex shrink-0 items-center gap-1">
          <Popover>
            <PopoverTrigger
              className="flex size-7 cursor-pointer items-center justify-center rounded-md text-neutral-500 transition-colors hover:bg-neutral-100 hover:text-neutral-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500"
              aria-label="Open preferences"
            >
              <IconSettingsGear2 ariaHidden className="size-4" />
            </PopoverTrigger>
            <PopoverContent align="end" className="w-72 p-3 text-sm">
              <p className="mb-3 border-b border-neutral-200 pb-2 text-sm font-medium text-neutral-700">
                Preferences
              </p>
              <CallSummaryPreference />
            </PopoverContent>
          </Popover>
          <span className="text-sm text-neutral-500">
            Welcome, {firstName}
          </span>
        </div>
      )}
    </div>
  );
}
